import Domain from '@/orm/models/Domain/Domain';

export default function useDomain() {
  async function setDomain(domain) {
    await Domain.api().setDomain(domain);
  }

  async function getDomain() {
    try {
      const { response } = await Domain.api().getDomain();
      if (!response?.data?.data?.domain) {
        return null;
      }
      return response.data.data.domain;
    } catch (error) {
      return null;
    }
  }

  async function deleteDomain() {
    await Domain.deleteAll();
    await Domain.api().deleteDomain();
  }

  async function appliedCheckDomain(domain) {
    const { response } = await Domain.api().appliedCheckDomain(domain);
    const { data } = response.data;
    return data;
  }

  return {
    setDomain,
    getDomain,
    deleteDomain,
    appliedCheckDomain,
  };
}
